import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { useLenis } from "lenis/react";
import { ArrowUp } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { FLOATING_ACTIONS_THRESHOLD } from "../../config/floatingActions";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const lenis = useLenis();
  const reduceMotion = useReducedMotion();
  const { t } = useLanguage();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > FLOATING_ACTIONS_THRESHOLD);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    if (lenis) lenis.scrollTo(0, { duration: 1.4 });
    else window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8, y: 12 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 12 }}
          transition={{ duration: reduceMotion ? 0 : 0.35, ease: [0.16, 1, 0.3, 1] }}
          onClick={toTop}
          data-testid="back-to-top"
          aria-label={t("common.backToTop")}
          className="group fixed bottom-6 right-6 z-[60] grid h-12 w-12 place-items-center rounded-full bg-[#D92A47] text-[#F6F2EC] shadow-lg shadow-black/20 transition-colors hover:bg-[#b71e3a] md:h-14 md:w-14"
        >
          <ArrowUp
            size={20}
            strokeWidth={2}
            className="transition-transform duration-300 group-hover:-translate-y-0.5"
          />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
